import { IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY } from '@/constants/immediateNurseConsultation';
import { useSmsVerificationBlocked } from './useSmsVerificationBlocked';
import { useSmsCountdown } from './useSmsVerificationTimer';

type UseRetrySmsVerificationParams = {
  sendSmsRetryCount: number;
};

export const useSmsVerification = ({ sendSmsRetryCount }: UseRetrySmsVerificationParams) => {
  const { blocked } = useSmsVerificationBlocked({ sendSmsRetryCount });
  const { millisecondsLeft, setCountdown } = useSmsCountdown(IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY);

  const startSmsVerificationCountdown = (retryAfterMs: number) => {
    setCountdown(retryAfterMs);
  };

  const constructLabel = () => {
    if (blocked) {
      return 'Resend attempts exceeded';
    }

    if (millisecondsLeft > 0) {
      return 'You can retry again shortly';
    }

    return `Resend SMS`;
  };

  const retryPermitted = !blocked && millisecondsLeft === 0;

  return {
    startSmsVerificationCountdown,
    retryPermitted,
    label: constructLabel(),
    blocked,
  };
};
